module.exports = "<div>\n    <section head></section>\n    <div class=\"row-fluid\">\n        <div class=\"span9 spinnerParent\">\n            <div class=\"spinnerContainer\"><div us-spinner spinner-theme=\"general\" spinner-key=\"spinner-stealth_op_view\" spinner-start-active=\"true\"></div></div>\n            <div id=\"forcechart\" make-coi-chart></div>\n        </div>\n        <div class=\"span3\">\n            <div id=\"forcechartinfo\"></div>\n        </div>\n    </div>\n</div>";


/*****************
 ** WEBPACK FOOTER
 ** ./src/pages/views/stealth/stealth_op_view.html
 ** module id = 635
 ** module chunks = 0
 **/